import { TableCell, TableHead, TableRow } from '@mui/material';

interface SearchTableHeadersProps {
    rows: string[];
}

export const SearchTableHeaders = ({ rows }: SearchTableHeadersProps) => {
    return (
        <TableHead>
            <TableRow>
                {rows.map((row, index) => (
                    <TableCell key={index} style={{ borderColor: 'rgba(224, 224, 224, 1)' }}>
                        {row}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};
